import React, { Component } from 'react'

class SvgFile extends Component {
  render() {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
      >
        <g fill="#FFF" fillRule="nonzero">
          <path
            fillOpacity=".2"
            d="M11.916 0C5.346 0 0 5.346 0 11.916s5.346 11.917 11.916 11.917 11.917-5.346 11.917-11.917C23.833 5.346 18.488 0 11.916 0z"
          />
          <path d="M13.355 9.583V8.378c0-.181.009-.322.025-.42a.816.816 0 0 1 .115-.293.468.468 0 0 1 .289-.2c.133-.037.31-.055.53-.055h1.205V5h-1.926c-1.115 0-1.915.264-2.402.793-.487.53-.73 1.309-.73 2.338v1.452H9.018v2.41h1.443v6.992h2.894v-6.992h1.926l.255-2.41h-2.18z" />
        </g>
      </svg>
    )
  }
}

export default SvgFile
